import { Container } from '@/components/Elements';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Col, Flex, Row, Typography, Grid } from 'antd';

import { LOGO } from '@/constant/assets';
import WHATSAPP from '@/assets/images/social/whatsapp.png';

const { useBreakpoint } = Grid;

const OnboardHeader = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/auth');
  };

  const { md } = Grid.useBreakpoint();

  return (
    <header style={{ padding: '1.5rem 0' }}>
      <Container>
        <Row gutter={[20, 20]} align="middle" justify="space-between">
          <Col xs={5}>
            <Link to="/" style={{ minWidth: '120px' }}>
              <img
                src={LOGO}
                alt="Odin Mortgage & Tax"
                style={{
                  width: '100%',
                  maxWidth: '180px',
                  minWidth: '150px',
                }}
              />
            </Link>
          </Col>

          <Col xs={17}>
            <Flex justify="flex-end" align="center" gap={20}>
              <Flex align="center" gap={10}>
                {md && (
                  <Typography.Text style={{ margin: 0, whiteSpace: 'nowrap' }}>
                    Already have an account?
                  </Typography.Text>
                )}

                <Button
                  size="large"
                  style={{ width: md ? '120px' : '80px' }}
                  type="primary"
                  onClick={handleLoginClick}
                >
                  Login
                </Button>
              </Flex>

              <Button
                size="large"
                style={{ height: 'auto', whiteSpace: 'nowrap' }}
                onClick={() => window.open('https://wa.me/61480049917')}
                icon={<img style={{ width: '24px' }} src={WHATSAPP} alt="" />}
              >
                {md ? 'Chat with us for help' : ''}
              </Button>
            </Flex>
          </Col>
        </Row>
      </Container>
    </header>
  );
};

export default OnboardHeader;
